import { libraryFiltersReducer as libraryFilters } from '../modules/libraryFilters/store';
import { translationsReducer as translations } from './translations';
import { notificationsReducer as notifications } from '../components/Notifications/store';
import app from '../modules/app/store';
import { sidebarReducer as sidebar } from '../modules/sidebar/store';
import { customFormReducer } from '../store';

export const coreReducers = {
	libraryFilters,
	translations,
	form: customFormReducer,
	notifications,
	app,
	sidebar,
};
